module.exports = __webpack_public_path__ + "static/media/IPG_bkg.7d9fea9f.jpg";